/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOfferSource.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/powerbroker/offer-source";

export class AutogenModelOfferSource<RowType extends ModelRow> extends Endpoint<RowType, RowOfferSourceFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowOfferSource extends ModelRow<RowOfferSourceFields> {
    constructor() {
        super(AutogenUserSavedSearchEndpoint);
    }
}

export interface RowOfferSourceFields {
    descr: string;
    id: string;
    is_active: string;
}

